import React from 'react';
import { linkify } from '../../lib/linkify';

// Member-written text (posts, replies, video comments) with bare URLs made
// clickable. See src/lib/linkify.js for why it is bare URLs only.
//
// Wrapping: `[overflow-wrap:anywhere]` is what lets a long unbroken URL wrap
// inside the card. `break-words` alone doesn't — it only breaks a word that
// can't fit on a line of its own AND doesn't lower the min-content width, so a
// flex child still grows to the URL's full length and runs out of the card.
//
// Links open in a new tab (the event Register links' precedent, which also
// hands off to Safari in the iOS build). rel carries nofollow + ugc because
// this is user-generated content, and stopPropagation keeps a tap on a link
// inside a clickable card (CommunityScreen) from also opening the post.
const LinkifiedText = ({ text, as: Tag = 'p', className = '', trailing = null }) => {
  const segments = linkify(text);
  return (
    <Tag className={`whitespace-pre-wrap [overflow-wrap:anywhere] ${className}`}>
      {segments.map((segment, i) => (
        segment.type === 'link' ? (
          <a
            key={i}
            href={segment.href}
            target="_blank"
            rel="noopener noreferrer nofollow ugc"
            onClick={(e) => e.stopPropagation()}
            className="underline underline-offset-2 hover:opacity-80"
            style={{ color: 'var(--brand-primary)' }}
          >
            {segment.value}
          </a>
        ) : (
          <React.Fragment key={i}>{segment.value}</React.Fragment>
        )
      ))}
      {trailing}
    </Tag>
  );
};

export default LinkifiedText;
